module.exports = __webpack_public_path__ + "static/img/operateMonth.6806681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateMonth.png
// module id = MPHe
// module chunks = 1